module.exports = __webpack_public_path__ + "static/media/panorama-h-alt.cc53ad91.svg";